export default __webpack_public_path__ + "static/media/public-transportation.e5116ecd.svg";